import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { MailWarning, X } from "lucide-react";

// A slim yellow banner shown to signed-in customers whose email is not yet verified.
// Not shown for staff. Dismissible per-session (session-only, not persisted).
const VerifyEmailBanner = () => {
  const { user, refreshUser } = useApp();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  if (!user) return null;
  if (user.role !== "customer") return null;
  if (user.email_verified) return null;
  if (dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/verify-email/send");
      toast.success("Verification email sent", { description: `Please check ${user.email}` });
      refreshUser?.();
    } catch (e) {
      toast.error("Could not send", { description: e.response?.data?.detail || "" });
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="verify-email-banner" className="bg-yellow-100 border-b border-yellow-300 text-yellow-900">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-2 flex items-center gap-3 text-sm">
        <MailWarning size={16} className="shrink-0" />
        <div className="flex-1">
          Please confirm your email address to complete purchases and receive plan updates.
          <button data-testid="resend-verification-btn" onClick={resend} disabled={sending} className="ml-2 underline hover:no-underline font-medium">
            {sending ? "Sending…" : "Resend verification email"}
          </button>
        </div>
        <button data-testid="dismiss-verify-banner" onClick={() => setDismissed(true)} aria-label="Dismiss">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default VerifyEmailBanner;
